import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://lwtavcqjlervaqbcbfcu.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx3dGF2Y3FqbGVydmFxYmNiZmN1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc1Mzg3NjUsImV4cCI6MjA5MzExNDc2NX0.rO5PwSxLCGPUv_ETygLfJtQLElFC0VeyOg0UZtjqi3c'

export const supabase = createClient(supabaseUrl, supabaseKey)